import { useUserProfile } from './useUserProfile';
import { ACCESS_EDL_PERMISSION } from '../utils/effectiveAccess.utils';

/** Gate de producto EDL: permission access:edl de GET /me. */
export const useCanAccessEdl = (): boolean => {
  const { hasPermission, isLoading, directorySession } = useUserProfile();

  if (isLoading && !directorySession) {
    return false;
  }

  return hasPermission(ACCESS_EDL_PERMISSION);
};
